import { ViewChild, Input, Output, EventEmitter, ElementRef, OnInit, OnDestroy } from '@angular/core'
import { Observable, of } from 'rxjs'
import { FirestoreAccess } from 'src/lib/firestore-access'
import { CreatorComment } from 'src/lib/entity/live'
import { Component } from '@angular/core'
import { mergeMap } from 'rxjs/operators'
import {
  trigger,
  style,
  animate,
  transition,
  query,
  sequence,
} from '@angular/animations'
@Component({
  selector: 'maglive-creator-comment',
  templateUrl: './creator-comment.component.html',
  styleUrls: ['./creator-comment.component.scss'],
  animations: [
    trigger('fadein', [
      transition('void => *', [
        sequence([
          // 初期表示位置は不可視化しておく
          query('div', style({ opacity: 0, })),
          // スタート開始時間調整(ここでは0.1秒後に開始)
          query('div', animate('100ms', style({}))),
          // 1秒かけて可視化される
          query('div', animate('1000ms ease-out', style({ opacity: 1 }))),
        ]),
      ]),
    ]),
  ],
})
export class CreatorCommentComponent implements OnInit, OnDestroy {
  @Input() isScreenRotated: boolean
  @Input() liveId: string
  @Input() magazineCoverImage: string

  isShowCreatorComment = true
  creatorComment$: Observable<CreatorComment | string>
  isNewCommentReceived = false
  private preCreatorComment: string | undefined = undefined
  private isFirstView = true

  constructor(
    private firestoreAccess: FirestoreAccess,
  ) {}

  ngOnInit() {
    this.getCreatorComment()
  }

  ngOnDestroy() {
  }

  /**
   * クリエイターの固定コメントを取得する
   */
  private getCreatorComment(): void {
    this.creatorComment$ = this.firestoreAccess
      .getCreatorComment(this.liveId)
      .pipe(
        mergeMap((comment) => {
          if (comment.length === 0) {
            // 初回視聴時にコメントがない場合は表示しない
            if (this.isFirstView) {
              this.isShowCreatorComment = false
              this.isFirstView = false
            }
            return of('NOT_FOUND')
          } else if (
            comment[0].message.length === 0 ||
            comment[0].message === ' ' ||
            comment[0].message === '　'
          ) {
            if (this.isFirstView) {
              this.isShowCreatorComment = false
              this.isFirstView = false
            }
            return of('NOT_FOUND')
          } else {
            this.isFirstView = false
            this.noticeForCreatorComment(comment[0].message)
            comment[0].message = this.replaceUrlToLink(comment[0].message)
            return comment
          }
        })
      )
  }

  /**
   * コメントにURLが含まれる場合はaタグに置換する
   * @param str
   * @returns string
   */
  private replaceUrlToLink(str: string): string {
    const regExpPtn =
      /https?:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+/g

    const urls = str.match(regExpPtn)
    let result = ''

    if (urls !== null) {
      for (let i = 0; i < urls.length; i++) {
        let replaceTxt = `<a href='${urls[i]}' target="_blank" rel="noopener">${urls[i]}</a>`
        result = str.replace(regExpPtn, replaceTxt)
      }
      return result
    } else {
      return str
    }
  }

  /**
   * 新着通知機能
   * @param comment
   */
  private noticeForCreatorComment(comment: string): void {
    if (this.preCreatorComment === undefined) {
      this.preCreatorComment = comment
    } else if (comment !== this.preCreatorComment) {
      this.isNewCommentReceived = true
      this.preCreatorComment = comment
    } else {
      this.isNewCommentReceived = false
    }
  }

  /**
   * クリエイターコメントの開閉
   */
  toggleCreatorComment() {
    this.isShowCreatorComment = !this.isShowCreatorComment
  }
}
